import httpService from "services/http.service";

export const onboardingService = {
  // Landing Page
  trackClick: (claimCode, source) => 
    httpService.post("/onboarding/claim/click", { claim_code: claimCode, source }),

  getPublicTemplate: (claimCode) => 
    httpService.get(`/onboarding/public/template?claim=${claimCode}`),

  startSession: (claimCode, verification) => 
    httpService.post("/onboarding/claim/start", { claim_code: claimCode, verification }),

  // Session Management
  getSession: (sessionId) => 
    httpService.get(`/onboarding/session/${sessionId}`),

  saveStep: (stepKey, sessionId, payload) => 
    httpService.post(`/onboarding/session/${sessionId}/step`, { step_key: stepKey, payload }),

  // Billing
  getSubscriptionPreview: (sessionId) => 
    httpService.get(`/onboarding/session/${sessionId}/subscriptions/preview`),

  getSetupIntent: (sessionId) => 
    httpService.post(`/onboarding/session/${sessionId}/billing/setup-intent`),

  confirmBilling: (sessionId, setupIntentId, items) => 
    httpService.post(`/onboarding/session/${sessionId}/billing/confirm`, { 
      setup_intent_id: setupIntentId, 
      selected_lines: items 
    }),

  // Finalization
  completeOnboarding: (sessionId, attestData) => 
    httpService.post(`/onboarding/session/${sessionId}/complete`, attestData),

  createCustomer: (sessionId, payload) =>
    httpService.post(`/onboarding/session/${sessionId}/billing/create-customer`, payload),
  // New endpoints for claim status and continuation flow
  getClaimStatus: (claimId) =>
    httpService.get(`/onboarding/claims/${claimId}/status`),
  renderContinuationPage: (token) =>
    httpService.get(`/onboarding/continue/${token}`),
  completeCustomerContinuation: (token, payload = {}) =>
    httpService.post(`/onboarding/continue/${token}/complete`, payload),
};
